import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useSelector, useDispatch } from "react-redux";
import { State } from '../../state/reducers/general_reducer'
import { showSnackbar } from "../../state/actions";


const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CustomSnackbar() {

    const state = useSelector<State, State["show"]>(
        (state) => state.show
    );
    const dispatch = useDispatch();


    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(showSnackbar({ "open": false }));
    }

    return (
        <Snackbar open={state.open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={state.severity} sx={{ width: '100%' }}>
                <span>{state.msg}</span>
            </Alert>
        </Snackbar>
    )
}
